import React from 'react';
import Nav from '../components/Nav';
import Footer from '../components/Footer';
import { PageHero, SectionHeading } from '../components/PageBits';
import { mockData } from '../data/mock';

const Gallery = () => (
  <div className="min-h-screen bg-cream">
    <Nav transparent />
    <PageHero
      eyebrow="A Visual Journey"
      title="The Queensland Ranch Gallery"
      subtitle="Real moments captured across our seven-acre estate."
      image="/hero/hero-main.jpg"
    />

    <section className="py-20 bg-cream texture-linen">
      <div className="container mx-auto px-6">
        <SectionHeading eyebrow="Every Angle" title="The" accent="Estate" />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 max-w-7xl mx-auto">
          {mockData.gallery.map((img, i) => (
            <div key={i} className={`relative overflow-hidden rounded-lg shadow-lg border border-gold/20 group ${i === 0 ? 'col-span-2 row-span-2 aspect-square' : 'aspect-square'}`}>
              <img
                src={img.url}
                alt={img.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </section>

    <Footer />
  </div>
);

export default Gallery;
